import { ENUM_LABELS, type User, formatPersonName } from '#shared/types';
import { Card } from '#client/components/ui/Card';
import { DetailList } from '#client/components/ui/DetailList';
import { ResourceDetailPage } from '#client/components/ui/ResourceDetailPage';
import { RoleBadge } from '#client/components/ui/StatusBadge';
import { formatDateTime, dash } from '#client/lib/format';
import { useAuth } from '#client/providers/AuthProvider';
import { RESOURCE } from '#client/lib/routes';
import { UserPermissionsCard } from './UserPermissionsCard';

const PATH = RESOURCE.users;

export function UserDetailPage() {
  const { user: currentUser } = useAuth();

  return (
    <ResourceDetailPage<User>
      path={PATH}
      noun="user"
      editCapability="staff.edit"
      deleteCapability="staff.delete"
      // Deleting your own account would immediately invalidate your session.
      canDelete={(user) => user.id !== currentUser?.id}
      title={formatPersonName}
      subtitle={(user) => user.email}
      deleteLabel={formatPersonName}
    >
      {(user) => (
        <div className="c-form-stack">
          <Card title="Details">
            <DetailList
              items={[
                { label: 'First name', value: user.first_name },
                { label: 'Last name', value: dash(user.last_name) },
                { label: "Father's name", value: user.father_name },
                { label: 'Age', value: user.age },
                { label: 'Gender', value: ENUM_LABELS.gender[user.gender] },
                { label: 'Role', value: <RoleBadge role={user.role} /> },
                { label: 'Phone', value: user.phone_number },
                { label: 'Email', value: user.email },
                { label: 'Field', value: user.field },
                { label: 'Created', value: formatDateTime(user.created_at) },
              ]}
            />
          </Card>
          <UserPermissionsCard userId={user.id} />
        </div>
      )}
    </ResourceDetailPage>
  );
}
